import classNames from 'classnames';
import React, { cloneElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import DailyBased from '@/modules/workforce/Contracts/components/CreateAndEdit/Steps/ContractTypeInputs/DailyBased';
import UnitBase from '@/modules/workforce/Contracts/components/CreateAndEdit/Steps/ContractTypeInputs/UnitBase';
import { IContracts } from '@/modules/workforce/Contracts/types';
import { Typography } from '@/shared/components/atoms';

import Dollar from '~/images/contract/dollar.svg';
import Tree from '~/images/contract/tree.svg';

const ContractTypeInputs: React.FC = () => {
  const { t } = useTranslation('common');

  const contractTypes = [
    {
      id: 1,
      name: t('daily-rate-contract'),
      icon: <Dollar />,
      description: t('daily-rate-contract-description'),
    },
    {
      id: 0,
      name: t('piecework-rate-contract'),
      icon: <Tree />,
      description: t('piecework-rate-contract-description'),
    },
  ];

  const { watch, control } = useFormContext<IContracts.IAddContractSchema>();
  const dailyWageWatcher = watch('dailyWage');
  // const applicationMethodWatcher = watch('ApplicationMethod');

  const getCardStyles = (active: boolean) => {
    return classNames(
      active ? 'bg-secondary-90 text-green-300' : 'bg-background-neutral-100'
    );
  };

  const getSubtextStyle = (active: boolean) => {
    return !active ? 'text-surface-10' : undefined;
  };

  return (
    <div>
      <Typography weight='medium' className='mb-16'>
        {t('contract-type')}
      </Typography>
      <Controller
        control={control}
        name='dailyWage'
        render={({ field: { onChange } }) => (
          <div className='grid grid-cols-2 gap-20'>
            {contractTypes.map((contractType) => {
              const isActive = contractType.id === dailyWageWatcher;
              return (
                <div
                  key={contractType.id}
                  className={classNames(
                    'flex cursor-pointer flex-col gap-8 rounded-xl px-24 py-16',
                    // !canChangeOperationType && 'pointer-events-none opacity-5',
                    getCardStyles(isActive)
                  )}
                  onClick={() => {
                    onChange(contractType.id);
                  }}
                >
                  {cloneElement(contractType.icon, {
                    className: classNames(
                      'w-30 h-30',
                      isActive && 'fill-green-300'
                    ),
                  })}
                  <Typography weight='medium'>{contractType.name}</Typography>
                  <Typography
                    variant='caption'
                    className={getSubtextStyle(isActive)}
                  >
                    {contractType.description}
                  </Typography>
                </div>
              );
            })}
          </div>
        )}
      />
      {dailyWageWatcher === 1 && <DailyBased />}
      {dailyWageWatcher === 0 && <UnitBase />}
    </div>
  );
};

export default ContractTypeInputs;
